import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { COLORS } from "../../Constants/styles";

const CustomTextButton = ({ label = "Learn More", color = '#000000', href = "#" }) => {
    return (
        <motion.a
            href={href}
            style={{ textDecoration: "none", display: "inline-block" }}
            initial="initial"
            whileHover="hover"
        >
            <Box
                component={motion.div}
                variants={{
                    initial: {},
                    hover: { scale: 1.05 },
                }}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                }}
            >
                {/* Circle with Arrow */}
                <motion.div
                    variants={{
                        initial: {
                            width: 32,
                            backgroundColor: COLORS.accentLime,
                            color: COLORS.accentDarkGreen,
                        },
                        hover: {
                            width: 48,
                            backgroundColor: COLORS.accentDarkGreen,
                            color: COLORS.accentLime,
                        },
                    }}
                    transition={{ duration: 0.4 }}
                    style={{
                        height: 32,
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <ArrowForwardIcon fontSize="small" />
                </motion.div>

                {/* Text - No color change */}
                <Typography
                    variant="button"
                    sx={{
                        color: {color}, // Always black
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        fontFamily: "'Big Shoulders Text', sans-serif",
                        
                    }}
                >
                    {label}
                </Typography>
            </Box>
        </motion.a>
    );
};

export default CustomTextButton;
